// extracted by mini-css-extract-plugin
module.exports = {"root":"infopanelPopoverContent_root__2W5lu","title":"infopanelPopoverContent_title__3Dsdn"};